import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Menu,
  MenuItem,
  Skeleton,
  Stack,
  TextField,
  Typography,
  useMediaQuery
} from "@mui/material";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { useTheme } from "@mui/material/styles";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { BIBlue, BILightGrey, BILightYellow, BIRed } from "../../assets/helpers";
import { useLocation, useNavigate } from "react-router-dom";
import CampaignIcon from "@mui/icons-material/Campaign";
import moment from "moment";
import {
  setBuilderBucksCount,
  setChatCount,
  setDashboardData,
  setMainNotification,
  setSelectedcompany,
  setSelectedSiteId,
  setShowalert,
  setShowmapmodal,
  setShowReport,
  setSurveyLaterToday
} from "../../redux/actions/actions";
import { useDispatch } from "react-redux";
import { English } from "../../constant/EnglishFallback";
import { Getrequestcall } from "../../request/Getrequest";
import {
  FETCH_ADS,
  FETCH_DASHBOARD_DATA,
  FETCH_GOALS,
  GET_DAILY_CHALLENGE_SUMMARY,
  GET_SURVEY_DATE,
  GET_TIMESHEETGOAL_DETAIL,
  RAG_ASK,
  RAG_SAVE_CHATBOT_HISTORY_ID_DETAILS,
  SAVE_POST_PICTURE,
  SAVE_POSTS,
  SITE_ACTIVE,
  USER_REWARD_AMOUNT
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import SurveyModal from "../survey/SurveyModal";
import SurveyQuizModal from "../survey/SurveyQuizModal";
import ProgressBar from "../home/ProgressBar";
import Getcurrentlocation from "../common/Getcurrentlocation";
import AddIcon from "@mui/icons-material/Add";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import mapMarkerYellow from "../../assets/images/marker_yellow.png";
import {
  buildIdInfoCardSkeleton,
  expensesCardSkeleton,
  questionsSkeleton,
  SiteCardSkeleton,
  timesheetCardSkeleton,
  userInfoCardSkeleton
} from "./skeleton/SkeletonView";
import PostComment from "../new-community/PostComment";
import Addexpenses from "../expenses/Addexpenses";
import ViewExpenses from "../expenses/ViewExpenses";
import DailyChallengeCard from "./DailyChallengeCard";
import CloseIcon from "@mui/icons-material/Close";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import placeholder_img from "../../assets/images/placeholder_img.jpg";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import AddWebsiteModal from "../common/AddWebsiteModal";
import AddDescription from "../sites/AddDescription";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import Pages from "../../constant/ReportModel";
import AdsCarousel from "./AdsCarousel";
import { AdsCarouselSkeleton } from "./skeleton/SkeletonView";
import Fade from "@mui/material/Fade";
// Timesheet Components (using the refactored versions)
import AddEditTimesheetModel from "../timesheets/AddEditTimesheetModel";
import TimesheetViewModal from "../timesheets/models/TimesheetViewModal";
import SendTimesheet from "../timesheets/models/SendTimesheet";
import AddClockIn from "../timesheets/models/AddClockIn";
import Joblist from "../timesheets/Joblist";
import PictureViewer from "../common/PictureViewer";
import AdContainer from "../common/AdContainer";
import SendIcon from "@mui/icons-material/Send";
import ChatIcon from "@mui/icons-material/Chat";
import Chatbot from "./Chatbot";
import SmartToyIcon from "@mui/icons-material/SmartToy";

const Home = () => {
  //1. Declaration of hooks
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const didMountRef = useRef(false);
  const dailyChallengeRef = useRef(null);

  const isSmallScreen = useMediaQuery((theme) => theme?.breakpoints?.down("sm"));
  const isLessThan1200 = useMediaQuery((theme) => theme?.breakpoints?.down(1200));

  //2. Get the data from redux
  const {
    loginData,
    multiLanguageData,
    dashboardData,
    builderBucksCount,
    reportSuccess,
    jobSelectedLocation
  } = useSelector((state) => state?.main);

  const LanguageData = multiLanguageData?.DashBoard || {};
  const {
    TEXT_HI = English.DashBoard.TEXT_HI,
    TEXT_VIEW_PROFILE = English.DashBoard.TEXT_VIEW_PROFILE || "View Profile",
    TEXT_BUILDERBUCKS = English.DashBoard.TEXT_BUILDERBUCKS,
    BUTTON_EARN_BUILDERBUCKS = English.DashBoard.BUTTON_EARN_BUILDERBUCKS,
    TEXT_NEARBY_SITES = English.DashBoard.TEXT_NEARBY_SITES,
    TEXT_NO_SITES_AVAILABLE = English.DashBoard.TEXT_NO_SITES_AVAILABLE,
    TEXT_NO_LOCATION_PLACEHOLDER = English.DashBoard.TEXT_NO_LOCATION_PLACEHOLDER,
    TEXT_ENABLE_LOCATION = English.DashBoard.TEXT_ENABLE_LOCATION,
    TEXT_VIEW_SITES_ON_MAP = English.DashBoard.TEXT_VIEW_SITES_ON_MAP,
    TEXT_LOCATION_TEXT_1 = English.DashBoard.TEXT_LOCATION_TEXT_1,
    TEXT_LOCATION_TEXT_2 = English.DashBoard.TEXT_LOCATION_TEXT_2,
    TEXT_JOBS = English.DashBoard.TEXT_JOBS,
    TEXT_TIME = English.DashBoard.TEXT_TIME,
    TEXT_SEE_ALL = English.DashBoard.TEXT_SEE_ALL,
    TEXT_TIMESHEETS = English.DashBoard.TEXT_TIMESHEETS,
    TEXT_NO_TIMESHEET_PLACEHOLDER = English.DashBoard.TEXT_NO_TIMESHEET_PLACEHOLDER,
    TEXT_EXPENSES = English.DashBoard.TEXT_EXPENSES,
    TEXT_EXPENSES_PLACEHOLDER = English.DashBoard.TEXT_EXPENSES_PLACEHOLDER,
    TEXT_ANSWER_SUBMITTED = English.DashBoard.TEXT_ANSWER_SUBMITTED,
    TEXT_EARNED_BY_ANS = English.DashBoard.TEXT_EARNED_BY_ANS,
    BUTTON_LEARN_MORE = English.DashBoard.BUTTON_LEARN_MORE,
    TEXT_NEW_TIMESHEET = English.DashBoard.TEXT_NEW_TIMESHEET || "New Timesheet",
    TEXT_ADD_CLOCKIN = English.DashBoard.TEXT_ADD_CLOCKIN || "Clock In"
  } = LanguageData || {};

  const {
    TEXT_ADD_DESCRIPTION = English?.SiteDetail?.TEXT_ADD_DESCRIPTION,
    TEXT_REPORT = English?.SiteDetail?.TEXT_REPORT,
    TEXT_FLAG_ACTIVE = English?.SiteDetail?.TEXT_FLAG_ACTIVE,
    BUTTON_ADD_WEBSITE = English?.SiteDetail?.BUTTON_ADD_WEBSITE,
    TEXT_ADD_PICTURE = English?.SiteDetail?.TEXT_ADD_PICTURE
  } = multiLanguageData?.SiteDetail || {};

  const userId = loginData?.userInformation?.UserId;
  const accessToken = loginData?.accessToken;

  //3. Declaration of states - General
  const [surveyModal, setSurveyModal] = useState(false);
  const [currentUserLocation, setCurrentUserLocation] = useState({ lat: 0, lng: 0 });
  const [isLocationDefault, setIsLocationDefault] = useState(false);
  const [quizModal, setQuizModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openPostCommentModalWithSource, setOpenPostCommentModalWithSource] = useState(false);
  const [saveExpensesFlag, setSaveExpensesFlag] = useState(false);
  const [showAddExpensesModal, setShowAddExpensesModal] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [showEditExpensesModal, setShowEditExpensesModal] = useState(false);

  const [answerCount, setAnswercount] = useState(null);
  const [visibleQuestions, setVisibleQuestions] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [siteInfo, setSiteInfo] = useState([]);
  const [addSiteWebsiteModalOpen, setAddSiteWebsiteModalOpen] = useState(false);
  const [addDescriptionDialogOpen, setAddDescriptionDialogOpen] = useState(false);

  const [siteLoading, setSiteLoading] = useState([]);
  const [adsData, setAdsData] = useState([]);
  const [showDailyChallenge, setShowDailyChallenge] = useState(true);
  const [dailyChallengeSummary, setDailyChallengeSummary] = useState(null);

  // Timesheet-specific states
  const [showTimesheetModal, setShowTimesheetModal] = useState(false);
  const [showClockInModal, setShowClockInModal] = useState(false);
  const [selectedTimesheet, setSelectedTimesheet] = useState(null);
  const [timesheetAction, setTimesheetAction] = useState("add");
  const [selectedJob, setSelectedJob] = useState([]);
  const [selectedClockInJob, setSelectedClockInJob] = useState([]);
  const [seletetdClockInTimesheet, setSeletetdClockInTimesheet] = useState(null);
  const [showJoblist, setShowJoblist] = useState(false);
  const [goallist, setGoallist] = useState([]);
  const [userGoalData, setUserGoalData] = useState([]);
  const [imageArray, setImageArray] = useState([]);
  const [pictureViewerOpen, setPictureViewer] = useState(false);
  const [imageIndex, setImageIndex] = useState(null);
  const [operation, setOperation] = useState("add");

  const [showSendTimesheet, setShowSendTimesheet] = useState(false);
  const [selectedTimesheetsToSend, setSelectedTimesheetsToSend] = useState([]);

  // Menu state for timesheet add options
  const [timesheetMenuAnchorEl, setTimesheetMenuAnchorEl] = useState(null);

  const [question, setQuestion] = useState("");
  const [chatbotLoader, setChatbotLoader] = useState(false);
  const [openChatbot, setOpenChatbot] = useState(false);
  const [chatbotResponse, setChatbotResponse] = useState([]); // keep full chat history
  const [chatbotSessionKey, setChatbotSessionKey] = useState(0);
  const currentChatHistoryIdRef = useRef(null);

  const open = Boolean(anchorEl);
  const timesheetMenuOpen = Boolean(timesheetMenuAnchorEl);
  const fileInputRef = useRef(null);

  const handleClickMoreMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const updateCurrentChatHistoryId = (historyId) => {
    const normalizedHistoryId = historyId ? Number(historyId) : null;
    currentChatHistoryIdRef.current = normalizedHistoryId;
  };

  const safeJsonParse = (value) => {
    if (typeof value !== "string") {
      return null;
    }

    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  };

  const parseHistoryAnswer = (rawAnswer) => {
    let answer = "";
    let sources = [];
    let videos = [];

    const assignFromObject = (data) => {
      if (!data || typeof data !== "object") {
        return;
      }

      answer = data?.Answer ?? data?.answer ?? data?.Description ?? data?.description ?? answer;

      const rawSources = data?.Sources ?? data?.sources ?? [];
      if (Array.isArray(rawSources)) {
        sources = rawSources;
      } else if (typeof rawSources === "string") {
        const parsedSources = safeJsonParse(rawSources);
        sources = Array.isArray(parsedSources) ? parsedSources : sources;
      }

      const rawVideos = data?.VideoTutorials ?? data?.videoTutorials ?? data?.Videos ?? data?.videos ?? [];
      if (Array.isArray(rawVideos)) {
        videos = [...rawVideos];
      } else if (typeof rawVideos === "string") {
        const parsedVideos = safeJsonParse(rawVideos);
        if (Array.isArray(parsedVideos)) {
          videos = [...parsedVideos];
        }
      }

      // Aggregate videoTutorials nested inside sources as well
      sources.forEach((source) => {
        const sourceVideos =
          source?.videoTutorial ??
          source?.VideoTutorial ??
          source?.videoTutorials ??
          source?.VideoTutorials;
        if (Array.isArray(sourceVideos)) {
          sourceVideos.forEach((v) => {
            if (v && !videos.some((exist) => exist.id === v.id || exist.fileUrl === v.fileUrl)) {
              videos.push(v);
            }
          });
        }
      });
    };

    if (typeof rawAnswer === "string") {
      const trimmedAnswer = rawAnswer.trim();
      if (!trimmedAnswer) {
        return { answer: "No answer available.", sources: [], videos: [] };
      }

      const parsedAnswer = safeJsonParse(trimmedAnswer);
      if (Array.isArray(parsedAnswer) && parsedAnswer.length > 0) {
        assignFromObject(parsedAnswer[0]);
      } else if (parsedAnswer && typeof parsedAnswer === "object") {
        assignFromObject(parsedAnswer);
      } else {
        answer = trimmedAnswer;
      }
    } else if (Array.isArray(rawAnswer) && rawAnswer.length > 0) {
      assignFromObject(rawAnswer[0]);
    } else if (rawAnswer && typeof rawAnswer === "object") {
      assignFromObject(rawAnswer);
    }

    return {
      answer: answer || "No answer available.",
      sources: Array.isArray(sources) ? sources : [],
      videos: Array.isArray(videos) ? videos : []
    };
  };

  const normalizeChatbotHistoryRecord = (item, fallbackId) => {
    const parsedAnswer = parseHistoryAnswer(item?.answer ?? item?.source ?? item?.Answer ?? "");

    return {
      id: item?.id ?? item?.historyDetailId ?? fallbackId ?? Date.now(),
      question: item?.question ?? item?.description ?? "",
      answer: parsedAnswer.answer,
      sources: parsedAnswer.sources,
      videos: parsedAnswer.videos || item?.videos || item?.videoTutorials || [],
      isPending: false,
      historyDetailId: item?.historyDetailId ?? item?.id ?? fallbackId ?? 0
    };
  };

  const clearCurrentChatThread = () => {
    updateCurrentChatHistoryId(null);
    setChatbotLoader(false);
    setChatbotResponse([]);
  };

  const resetChatbotToNewChat = () => {
    setQuestion("");
    clearCurrentChatThread();
    setChatbotSessionKey((prev) => prev + 1);
    setOpenChatbot(true);
  };

  // Timesheet menu handlers
  const handleTimesheetMenuClick = (event) => {
    setTimesheetMenuAnchorEl(event.currentTarget);
  };

  const handleTimesheetMenuClose = () => {
    setTimesheetMenuAnchorEl(null);
  };

  const handleSendTimesheet = (timesheetDetail) => {
    // Handle sending a single timesheet or array of timesheets
    const timesheetsToSend = Array.isArray(timesheetDetail) ? timesheetDetail : [timesheetDetail];
    setSelectedTimesheetsToSend(timesheetsToSend);
    setShowSendTimesheet(true);
  };

  const isInitialLoadedRef = useRef(false);

  // 4. Declaration of useEffect
  useEffect(() => {
    if (isInitialLoadedRef.current) return;
    isInitialLoadedRef.current = true;

    const callInitialStage = async () => {
      setIsLoading(true);
      // callNotificationcount();
      await Promise.all([fetchDashboardData(), getDateDiffForSurvey(), fetchAdsData(), fetchDailyChallengeSummary()]);
      setVisibleQuestions(true);
    };
    callInitialStage();
  }, []);

  // After add report to site refresh the site listing
  useEffect(() => {
    if (reportSuccess === true) {
      setIsLoading(true);
      fetchDashboardData();
      dispatch(setReportSuccess(false));
    }
  }, [reportSuccess]);

  const [autoOpenDailyChallenge, setAutoOpenDailyChallenge] = useState(false);

  // Handle Deep link navigation from notification for Daily Challenge
  useEffect(() => {
    const searchParams = new URLSearchParams(location?.search || "");
    const isDailyChallengeFromState =
      location?.state?.from === "from-notification" && location?.state?.showDailyChallenge;
    const isDailyChallengeFromQuery =
      searchParams.get("showDailyChallenge") === "true";

    const shouldOpenModal =
      location?.state?.openDailyChallengeModal === true ||
      searchParams.get("openModal") === "true";

    if (isDailyChallengeFromState || isDailyChallengeFromQuery) {
      setShowDailyChallenge(true);
      if (shouldOpenModal) {
        setAutoOpenDailyChallenge(true);
      }
      const scrollTimer = setTimeout(() => {
        dailyChallengeRef?.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 500);
      return () => clearTimeout(scrollTimer);
    }
  }, [location?.state, location?.search]);

  // ✅ Timesheet Functions
  const fetchGoalData = async () => {
    try {
      // Fetch user goals
      const goalsResponse = await Postrequestcall(
        FETCH_GOALS,
        {
          PageNr: 1,
          FullSearch: "",
          UserId: loginData?.userInformation?.UserId,
          IncludeRecordNr: true,
          SearchList: [{ createdBy: loginData?.userInformation?.UserId }]
        },
        loginData?.accessToken
      );

      if (goalsResponse?.data?.data) {
        const formattedGoals = goalsResponse.data.data.map((goal) => ({
          ...goal,
          key: goal.id,
          value: goal.name
        }));
        setUserGoalData(formattedGoals);
      }

      // Fetch goal details
      const goalDetailResponse = await Getrequestcall(
        `${GET_TIMESHEETGOAL_DETAIL}/${loginData?.userInformation?.UserId}`,
        loginData?.accessToken
      );

      if (goalDetailResponse.status === 200) {
        setGoallist(goalDetailResponse?.data?.data);
      }
    } catch (error) {
      console.error("fetchGoalData-> Error fetching goal data: ", error);
    }
  };

  const handleClick = async () => {
    setTimesheetAction("add");
    setSelectedTimesheet(null);
    setSelectedJob([]);
    setOperation("add");

    // Fetch goal data when opening timesheet modal
    await fetchGoalData();

    setShowTimesheetModal(true);
    handleTimesheetMenuClose();
  };

  const handleClockInClick = async () => {
    setOperation("add");
    setSeletetdClockInTimesheet(null);
    setSelectedClockInJob([]);

    // Fetch goal data when opening clock-in modal
    await fetchGoalData();

    setShowClockInModal(true);
    handleTimesheetMenuClose();
  };

  const onTimesheetViewclick = (e, item) => {
    setTimesheetAction("view");
    setSelectedTimesheet(item);
    setShowTimesheetModal(true);
  };

  const handleTimesheetSaveComplete = async () => {
    // Refresh dashboard data after timesheet operations

    await fetchDashboardData();
    setShowTimesheetModal(false);
    setShowClockInModal(false);
    setSelectedJob([]);
    setSelectedClockInJob([]);
    setSelectedTimesheet(null);
    setSeletetdClockInTimesheet(null);
    setTimesheetAction("add");
    setOperation("add");
  };

  // Other existing functions...
  const fetchDashboardData = async () => {
    const currentLocation = await Getcurrentlocation(multiLanguageData);

    // Set isLocationDefault state
    const isDefault = currentLocation?.default === true;
    setIsLocationDefault(isDefault);

    // Update currentUserLocation state - use (0,0) if default to match API logic
    if (isDefault) {
      setCurrentUserLocation({ lat: 0, lng: 0 });
    } else {
      setCurrentUserLocation({ lat: currentLocation?.lat || 0, lng: currentLocation?.lng || 0 });
    }

    try {
      let postObj = {};
      if (isDefault) {
        postObj = {
          UserId: userId,
          UserLatitude: 0,
          UserLongitude: 0,
          JobLatitude: jobSelectedLocation?.lat || 0,
          JobLongitude: jobSelectedLocation?.lng || 0,
          RadiusKm: jobSelectedLocation?.range || 80
        };
      } else {
        postObj = {
          UserId: userId,
          UserLatitude: currentLocation?.lat || 0,
          UserLongitude: currentLocation?.lng || 0,
          JobLatitude: jobSelectedLocation?.lat || currentLocation?.lat || 0,
          JobLongitude: jobSelectedLocation?.lng || currentLocation?.lng || 0,
          RadiusKm: jobSelectedLocation?.range || 80
        };
      }
      const response = await Postrequestcall(FETCH_DASHBOARD_DATA, postObj, accessToken);
      dispatch(setMainNotification(response?.data?.data?.[0]?.notificationCount));
      // Use chat count from dashboard data as requested
      // dispatch(setChatCount(response?.data?.data?.[0]?.notificationCount ?? 0));
      dispatch(setDashboardData(response?.data?.data?.[0]));
      dispatch(setBuilderBucksCount(response?.data?.data[0]?.builderBucksCount ?? 0));
    } catch (error) {
      console.error("fetchDashboardData-> Error Fetching Dashboard Data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAdsData = async () => {
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: "",
        UserId: userId,
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        SearchList: [
          {
            Active: true
          }
        ],
        SortList: [
          {
            FieldName: "orderNo",
            Direction: "ASC"
          }
        ]
      };
      let adsRes = await Postrequestcall(FETCH_ADS, obj, loginData?.accessToken);
      setAdsData(adsRes?.data?.data || []);
    } catch (error) {
      console.log("FetchAdsData-> Error When Getting Ads Data: ", error);
    }
  };

  const fetchDailyChallengeSummary = async () => {
    if (!userId) return;
    try {
      const summaryUrl = `${GET_DAILY_CHALLENGE_SUMMARY}${userId}`;
      const summaryRes = await Getrequestcall(summaryUrl, loginData?.accessToken);
      const summaryData = summaryRes?.data?.data?.[0];
      setDailyChallengeSummary(summaryData || null);

      const storedDate = localStorage.getItem("dailyChallenge_maybeLaterDate");
      const storedVal = localStorage.getItem("dailyChallenge_maybeLater");
      const todayDateStr = new Date().toISOString().split("T")[0];
      const isMaybeLaterToday = storedVal === "true" && storedDate === todayDateStr;

      const isMaybeLater = isMaybeLaterToday || summaryData?.questionsMaybelater === true;
      setShowDailyChallenge(true);
    } catch (e) {
      console.error("Error fetching daily challenge summary status", e);
    }
  };

  // 5. API calling Function

  const getDateDiffForSurvey = async () => {
    try {
      const response = await Getrequestcall(`${GET_SURVEY_DATE}/${userId}`, loginData?.accessToken);
      const a = moment(new Date());
      const b = moment(response?.data?.data?.[0].joinedBuildIdDate);
      const diffInDays = a.diff(b, "days");
      if (!response?.status) {
        setSurveyModal(false);
        return;
      }

      if (diffInDays == 30 && response?.data?.data?.[0]?.surveyDate == "1900-01-01T00:00:00") {
        setSurveyModal(true);
      } else {
        if (
          moment(new Date()).format("YYYY-MM-DD") ==
            moment(response?.data?.data?.[0]?.surveyDate).format("YYYY-MM-DD") &&
          surveyLaterToday !== "true"
        ) {
          dispatch(setSurveyLaterToday("false"));
          setSurveyModal(true);
        } else {
          if (
            moment(response?.data?.data?.[0]?.surveyDate).format("YYYY-MM-DD") != "1900-01-01" &&
            moment(response?.data?.data?.[0]?.surveyDate).format("YYYY-MM-DD") <
              moment(new Date()).format("YYYY-MM-DD")
          ) {
            setSurveyModal(true);
          } else {
            setSurveyModal(false);
          }
        }
      }
    } catch (error) {
      console.log(
        "getDateDiffForSurvey-> Error Getting Dashboard Notification Count(For Survey Date): " +
          error
      );
    }
  };

  // 6. Other event handlers
  const handleInfoToggler = () => {
    setOpenPostCommentModalWithSource(true);
  };

  const handleSiteInfo = (item) => {
    dispatch(setSelectedSiteId(item?.id));
    dispatch(setSelectedcompany()); // store the company details in redux
    let mapModal = {
      open: true,
      from: "dashboard",
      select: "site"
    };
    dispatch(setShowmapmodal(mapModal));
  };

  const convertToHoursAndMinutes = (decimalHours) => {
    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60);
    return { hours, minutes };
  };

  const learnMore = () => {
    navigate("/reward-store");
  };

  const goToTimesheet = () => {
    navigate("/timesheets");
  };

  const goToSites = () => {
    navigate("/sites");
  };

  const goToExpenses = () => {
    navigate("/expenses");
  };

  const goToProfile = () => {
    navigate(`/${userId}`);
  };

  const goToRewardActivity = () => {
    navigate("/reward-store/earn-builderbucks/earn-rewards");
  };

  const renderCityText = (city, country) => {
    let address = "";
    if (city && country) {
      address = city + ", " + country;
    } else if (city) {
      address = city;
    } else if (country) {
      address = country;
    }
    return address?.trim();
  };

  const LocationAlert = () => {
    const alertObj = {
      showAlert: true,
      text: TEXT_LOCATION_TEXT_1,
      text2: TEXT_LOCATION_TEXT_2
    };
    dispatch(setShowalert(alertObj));
  };

  const setSiteActiveStatus = async (mainId) => {
    try {
      let payload = {
        UserId: loginData?.userInformation?.UserId,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: mainId
          }
        ]
      };
      let getResponse = await Postrequestcall(SITE_ACTIVE, payload, loginData?.accessToken);
      if (getResponse.status === 201) {
        let id = siteLoading;
        id.pop(mainId || 0);
        let clone = dashboardData?.sites;

        const updatedData = clone?.map((site) => {
          if (site?.id === mainId) {
            return {
              ...site,
              active: true
            };
          } else {
            return site;
          }
        });
        dispatch(
          setDashboardData({
            ...dashboardData,
            sites: updatedData
          })
        );
        setSiteLoading(id);
      }
      setAnchorEl(false);
    } catch (error) {
      let id = siteLoading;
      id.pop(mainId || 0);
      setSiteLoading(id);
      console.log("setSiteActiveStatus-> Error When Making Site Active: ", error);
    }
  };

  const openSiteReport = () => {
    let reportObj = {
      showReport: true,
      name: Pages?.site?.name,
      AppScreenId: Pages?.site?.id,
      recordId: siteInfo?.id ?? 0
    };
    dispatch(setShowReport(reportObj));
    setAnchorEl(false);
  };

  const handleSiteImageSelect = async (event) => {
    try {
      const files = Array.from(event.target.files);
      if (!files.length) {
        return;
      }
      const userId = Number(loginData?.userInformation?.UserId);
      const siteId = siteInfo?.id ?? 0;
      const obj = {
        UserId: userId,
        ReturnRecordId: true,
        ReturnRecordError: false,
        SaveList: [
          {
            Id: 0,
            FormatTypeId: 1,
            PostedByUserId: userId,
            AppId: 2,
            AppRecordId: siteId,
            Message: "<<<picture>>>",
            ModifiedBy: userId
          }
        ]
      };
      const postRes = await Postrequestcall(SAVE_POSTS, obj, loginData?.accessToken);
      const postId = postRes?.data?.data?.[0]?.objData?.id;
      let inappropriateFound = false;
      if (!postId) throw new Error("Post ID not returned from SAVE_POSTS");

      const results = await Promise.allSettled(
        files.map((file) => {
          const formData = new FormData();
          formData.append("Id", 0);
          formData.append("PostId", postId);
          formData.append("ModifiedBy", userId);
          formData.append("Pictures", file);
          return Fileuploadrequestcall(SAVE_POST_PICTURE, formData, loginData?.accessToken);
        })
      );

      results.forEach((result) => {
        if (result.status === false) {
          inappropriateFound = true;
        } else if (result.value.data.message === "Content Inappropriate") {
          inappropriateFound = true;
        }
      });

      if (inappropriateFound) {
        alert(
          "One or more images have been restricted from being uploaded due to inappropriate content."
        );
      }
    } catch (error) {
      console.error("handleSiteImageSelect-> Error When Saving Site Picture: ", error);
    }
  };

  // Card rendering functions...
  const userInfoCard = () => {
    return (
      <Card
        sx={{
          borderRadius: "16px",
          background: `linear-gradient(135deg, ${BIBlue} 0%, #062a85 100%)`,
          boxShadow: "0 10px 30px rgba(8, 61, 184, 0.15)",
          color: "white",
          p: 2,
          position: "relative",
          overflow: "hidden",
          border: "none",
          transition: "transform 0.3s ease, box-shadow 0.3s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 20px 40px rgba(8, 61, 184, 0.25)"
          }
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "-50px",
            right: "-50px",
            width: "130px",
            height: "130px",
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.05)",
            pointerEvents: "none"
          }}
        />
        <Stack spacing={1.5}>
          <Stack
            direction="row"
            sx={{ justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}
            onClick={goToProfile}
          >
            <Stack>
              <Typography variant="h5" sx={{ color: "white", fontWeight: "900", letterSpacing: "-0.5px", fontSize: "20px" }}>
                {TEXT_HI} {loginData?.userInformation?.FirstName}!
              </Typography>
              <Typography
                variant="subtitle2"
                noWrap
                sx={{
                  color: "rgba(255, 255, 255, 0.8)",
                  fontSize: "12px",
                  mt: 0.3,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  fontWeight: "600"
                }}
              >
                {TEXT_VIEW_PROFILE}
                <KeyboardArrowRightIcon
                  fontSize="small"
                  sx={{ fontWeight: "bolder" }}
                />
              </Typography>
            </Stack>
            <Avatar
              sx={{
                width: 48,
                height: 48,
                border: "3px solid rgba(255, 255, 255, 0.2)",
                boxShadow: "0 4px 10px rgba(0,0,0,0.15)"
              }}
              alt="contact-PictureUrl"
              src={dashboardData?.userPicture}
            />
          </Stack>

          <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
            <Stack sx={{ alignItems: "baseline" }} direction="row" spacing={0.5}>
              <Typography sx={{ color: "white", fontWeight: "900", fontSize: "26px", lineHeight: 1 }} variant="h4">
                {builderBucksCount}
              </Typography>
              <Typography sx={{ color: "rgba(255, 255, 255, 0.8)", fontWeight: "700", fontSize: "13px" }} variant="body2">
                {TEXT_BUILDERBUCKS}
              </Typography>
            </Stack>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "white",
                color: BIBlue,
                borderRadius: "12px",
                px: 2,
                py: 0.6,
                fontWeight: "800",
                fontSize: "12px",
                textTransform: "none",
                boxShadow: "0 4px 12px rgba(255,255,255,0.15)",
                "&:hover": {
                  backgroundColor: "#f8fafc",
                  boxShadow: "0 6px 16px rgba(255,255,255,0.25)"
                }
              }}
              onClick={goToRewardActivity}
            >
              {BUTTON_EARN_BUILDERBUCKS}
            </Button>
          </Stack>
        </Stack>
      </Card>
    );
  };

  const buildIdInfoCard = () => {
    const hasCustomColor = dashboardData?.announcement?.color;
    const backgroundColor = hasCustomColor || BILightYellow;
    const textColor = hasCustomColor ? "white" : "inherit";

    return (
      <Card
        className="pagelist-content"
        sx={{ height: "130px", backgroundColor, cursor: "pointer" }}>
        <Stack spacing={1} direction={"row"} sx={{ p: 2 }} onClick={handleInfoToggler}>
          <CampaignIcon sx={{ color: textColor }} />
          <Typography sx={{ color: textColor }}>{dashboardData?.announcement?.message}</Typography>
        </Stack>
      </Card>
    );
  };

  const progressCard = () => {
    return <ProgressBar from={"new-dashboard"} dashboardData={dashboardData} />;
  };

  const siteCard = () => {
    return (
      <Card
        sx={{
          borderRadius: "16px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.03)",
          border: "1px solid #f1f5f9",
          p: 3,
          height: dashboardData?.sites?.length !== 0 ? (isSmallScreen ? "280px" : "330px") : "200px",
          transition: "transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.06)",
            borderColor: "#cbd5e1"
          }
        }}
      >
        <Stack spacing={2.5}>
          <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
            <Typography sx={{ cursor: "pointer", fontWeight: "900", letterSpacing: "-0.5px" }} variant="h5" onClick={goToSites}>
              {TEXT_NEARBY_SITES}
            </Typography>
            <Button
              color="primary"
              variant="outlined"
              sx={{ textTransform: "none", borderRadius: "10px", fontWeight: "700" }}
              onClick={goToSites}>
              {TEXT_VIEW_SITES_ON_MAP}
            </Button>
          </Stack>
          {dashboardData?.sites !== null && dashboardData?.sites?.length !== 0 ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  overflowX: "auto",
                  scrollbarWidth: "none",
                  gap: 2.5
                }}>
                {dashboardData?.sites?.map((item, index) => (
                  <>
                    {!siteLoading.includes(item?.id) ? (
                      <Card
                        key={index}
                        sx={{
                          width: isSmallScreen ? 180 : 260,
                          flex: "0 0 auto",
                          borderRadius: "16px",
                          border: "1px solid #e2e8f0",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.02)",
                          overflow: "hidden",
                          cursor: "pointer",
                          transition: "transform 0.3s ease, box-shadow 0.3s ease",
                          "&:hover": {
                            transform: "scale(1.02)",
                            boxShadow: "0 8px 24px rgba(0,0,0,0.08)"
                          }
                        }}
                        onClick={() => handleSiteInfo(item)}>
                        <Box
                          sx={{
                            position: "relative",
                            width: "100%",
                            height: isSmallScreen ? 100 : 130
                          }}>
                          <Box
                            component="img"
                            src={item?.sitePicture === "" ? placeholder_img : item?.sitePicture}
                            onError={(event) => (event.target.src = placeholder_img)}
                            alt="No Image"
                            loading="lazy"
                            sx={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              cursor: "pointer"
                            }}
                          />
                        </Box>
                        <Stack direction="row" sx={{ p: 2, alignItems: "center", justifyContent: "space-between", display: "flex" }}>
                          <Stack>
                            <Typography variant="body1">{item?.name || "Unnamed Site"}</Typography>
                            <Typography variant="body2" sx={{ color: "text.secondary" }}>
                              {item?.address}
                            </Typography>
                            <Typography variant="body2" sx={{ color: "text.secondary" }}>
                              {renderCityText(item?.city, item?.country)}
                            </Typography>
                          </Stack>
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              setSiteInfo(item);
                              handleClickMoreMenu(e);
                            }}>
                            <MoreIcon />
                          </IconButton>
                        </Stack>
                      </Card>
                    ) : (
                      <Card
                        className="pagelist-content"
                        key={siteInfo?.id}
                        sx={{
                          width: isSmallScreen ? 200 : 300,
                          flex: "0 0 auto"
                        }}>
                        <Skeleton
                          variant="rectangular"
                          width="100%"
                          height={isSmallScreen ? 160 : 195}
                          sx={{ bgcolor: "grey.500" }}
                        />
                        <Box sx={{ p: 2 }}>
                          <Skeleton
                            variant="text"
                            width="80%"
                            height={24}
                            sx={{ bgcolor: "grey.500" }}
                          />
                          <Skeleton
                            variant="text"
                            width="60%"
                            height={20}
                            sx={{ bgcolor: "grey.500" }}
                          />
                          <Skeleton
                            variant="text"
                            width="40%"
                            height={20}
                            sx={{ bgcolor: "grey.500" }}
                          />
                        </Box>
                      </Card>
                    )}
                  </>
                ))}
                <Menu
                  id="demo-positioned-menu"
                  aria-labelledby="demo-positioned-button"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}>
                  {siteInfo?.active ? null : (
                    <MenuItem
                      onClick={() => {
                        let id = [...siteLoading];
                        id.push(siteInfo?.id || 0);
                        setSiteLoading(id);
                        setSiteActiveStatus(siteInfo?.id);
                        setAnchorEl(false);
                      }}
                      style={{ color: BIBlue }}
                      dense>
                      {TEXT_FLAG_ACTIVE}
                    </MenuItem>
                  )}

                  {(siteInfo?.address !== "" ||
                    siteInfo?.latitude !== 0 ||
                    siteInfo?.longitude !== 0) && (
                    <MenuItem
                      style={{ color: BIBlue }}
                      dense
                      onClick={() => {
                        fileInputRef.current.click();
                        setAnchorEl(false);
                      }}>
                      {TEXT_ADD_PICTURE}
                    </MenuItem>
                  )}

                  <MenuItem
                    style={{ color: BIBlue }}
                    dense
                    onClick={() => {
                      setAddDescriptionDialogOpen(true);
                      setAnchorEl(false);
                    }}>
                    {TEXT_ADD_DESCRIPTION}
                  </MenuItem>
                  {(siteInfo?.website === "" || siteInfo?.website === null) && (
                    <MenuItem
                      style={{ color: BIBlue }}
                      dense
                      onClick={() => {
                        setAddSiteWebsiteModalOpen(true);
                        setAnchorEl(false);
                      }}>
                      {BUTTON_ADD_WEBSITE}
                    </MenuItem>
                  )}

                  <MenuItem
                    style={{ color: BIRed }}
                    dense
                    onClick={() => {
                      openSiteReport();
                    }}>
                    {TEXT_REPORT}
                  </MenuItem>
                </Menu>

                <input
                  type="file"
                  accept="image/*"
                  multiple
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={handleSiteImageSelect}
                />
              </Box>
            </>
          ) : dashboardData?.sites == null ? (
            <Box
              gap={1}
              sx={{ alignItems: "center",  justifyContent: "center",  display: "flex" }}
              direction={"column"}
              
              >
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                {TEXT_NO_SITES_AVAILABLE}
              </Typography>
            </Box>
          ) : (
            <Box
              gap={1}
              sx={{ alignItems: "center",  justifyContent: "center",  display: "flex" }}
              direction={"column"}
              
              >
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                {TEXT_NO_LOCATION_PLACEHOLDER}
              </Typography>
              <Button variant="text" onClick={LocationAlert}>
                {TEXT_ENABLE_LOCATION}
              </Button>
            </Box>
          )}
        </Stack>
      </Card>
    );
  };

  const jobCard = () => {
    return (
      <Card
        sx={{
          borderRadius: "16px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.03)",
          border: "1px solid #f1f5f9",
          p: 3,
          height: isSmallScreen ? "280px" : "300px",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          transition: "transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.06)",
            borderColor: "#cbd5e1"
          }
        }}
      >
        <Stack spacing={2.5} sx={{ height: "100%", flexGrow: 1 }}>
          <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
            <Typography sx={{ fontWeight: "900", letterSpacing: "-0.5px" }} variant="h5">
              {"Nearby Jobs"}
            </Typography>
            <Button
              color="primary"
              variant="outlined"
              sx={{ textTransform: "none", borderRadius: "10px", fontWeight: "700" }}
              onClick={() => navigate("/job-postings")}>
              Search job postings
            </Button>
          </Stack>
          {dashboardData?.jobPosts?.length > 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                overflowX: "auto",
                scrollbarWidth: "none",
                gap: 2.5
              }}>
              {dashboardData?.jobPosts?.map((job) => (
                <Card
                  key={job.id}
                  onClick={() => navigate("/job-postings", { state: { jobId: job.id } })}
                  sx={{
                    width: isSmallScreen ? 180 : 260,
                    flex: "0 0 auto",
                    borderRadius: "16px",
                    border: "1px solid #e2e8f0",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.02)",
                    overflow: "hidden",
                    cursor: "pointer",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.02)",
                      boxShadow: "0 8px 24px rgba(0,0,0,0.08)"
                    }
                  }}>
                  <Box
                    sx={{
                      position: "relative",
                      width: "100%",
                      height: isSmallScreen ? 100 : 130,
                      backgroundColor: "#f8fafc",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden"
                    }}>
                    <Box
                      component="img"
                      src={job?.site?.sitePicture || placeholder_img}
                      onError={(event) => (event.target.src = placeholder_img)}
                      alt="Job Image"
                      loading="lazy"
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                      }}
                    />
                  </Box>
                  <Stack sx={{ p: 2 }} spacing={0.5}>
                    <Typography variant="body1" sx={{ fontWeight: "700" }} noWrap title={job.title}>
                      {job.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: "600" }} noWrap title={job?.companyName}>
                      {job?.companyName || "No Company Name"}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "text.secondary" }} noWrap title={job?.siteName || job?.site?.name}>
                      {job?.siteName || job?.site?.name || "Site Location"}
                    </Typography>
                  </Stack>
                </Card>
              ))}
            </Box>
          ) : isLocationDefault ||
            (currentUserLocation.lat === 0 && currentUserLocation.lng === 0) ? (
            <Box
              gap={1}
              sx={{ flexGrow: 1, alignItems: "center", justifyContent: "center", display: "flex" }}
              direction={"column"}
            >
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                {TEXT_NO_LOCATION_PLACEHOLDER}
              </Typography>
              <Button variant="text" onClick={LocationAlert}>
                {TEXT_ENABLE_LOCATION}
              </Button>
            </Box>
          ) : (
            <Box
              gap={1}
              sx={{ flexGrow: 1, alignItems: "center", justifyContent: "center", display: "flex" }}
              direction={"column"}
            >
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                No jobs available
              </Typography>
            </Box>
          )}
        </Stack>
      </Card>
    );
  };

  const answerCard = () => {
    return (
      <>
        <Card className="pagelist-content" sx={{ backgroundColor: BILightGrey, width: "100%" }}>
          <CardContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between"
              }}>
              <Typography sx={{ ml: 1, color: "text.secondary" }} variant="body2">
                {TEXT_ANSWER_SUBMITTED}
              </Typography>
              <IconButton
                size="small"
                color="default"
                onClick={() => {
                  setVisibleQuestions(false);
                  setAnswercount(null);
                }}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Box
              sx={{ alignItems: "center",  justifyContent: "center",  display: "flex" }}
              direction={"column"}
              
              >
              <EmojiEventsIcon sx={{ height: "208px", width: "208px", color: "#ffbc0a" }} />
              <Typography variant="h3" sx={{ color: "primary" }}>
                {answerCount} {TEXT_BUILDERBUCKS}
              </Typography>

              <Typography sx={{ mt: 1, color: "text.secondary" }} variant="body2">
                {TEXT_EARNED_BY_ANS}
                <Button variant="text" size="small" onClick={learnMore}>
                  {BUTTON_LEARN_MORE}
                </Button>
              </Typography>
            </Box>
          </CardContent>
        </Card>
      </>
    );
  };

  const timesheetCard = (isRightColumn = false) => {
    return (
      <Card
        sx={{
          borderRadius: "16px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.03)",
          border: "1px solid #f1f5f9",
          p: 2.5,
          cursor: "pointer",
          height: "100%",
          minHeight: isRightColumn ? "295px" : "260px",
          display: "flex",
          flexDirection: "column",
          transition: "transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.06)",
            borderColor: "#cbd5e1"
          }
        }}
      >
        <Stack spacing={1.5} sx={{ height: "100%", flexGrow: 1 }}>
          <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"}>
            <Typography sx={{ cursor: "pointer", fontWeight: "900", letterSpacing: "-0.5px" }} variant="h5" onClick={goToTimesheet}>
              {TEXT_TIMESHEETS}
            </Typography>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <IconButton onClick={handleTimesheetMenuClick}>
                <AddIcon />
              </IconButton>
              {dashboardData?.timeSheets?.length > 0 && (
                <Button
                  size="small"
                  color="inherit"
                  variant="contained"
                  sx={{ textTransform: "none", borderRadius: "12px", boxShadow: "none", fontSize: "12px", py: 0.5, px: 1.5 }}
                  onClick={goToTimesheet}>
                  {TEXT_SEE_ALL}
                </Button>
              )}
            </Stack>
          </Stack>
          {dashboardData?.timeSheets !== null && dashboardData?.timeSheets?.length > 0 ? (
            <List disablePadding sx={{ flexGrow: 1, maxHeight: isRightColumn ? "320px" : "auto", overflowY: isRightColumn ? "auto" : "visible" }}>
              <Stack spacing={1}>
                {dashboardData?.timeSheets?.map((item, index) => {
                  const { hours, minutes } = convertToHoursAndMinutes(item?.totalHours || 0);
                  return (
                    <Card
                      key={index.toString()}
                      sx={{
                        borderRadius: "12px",
                        border: "1px solid #f1f5f9",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.01)"
                      }}
                    >
                      <ListItem sx={{ m: 0 }} key={index.toString()} disablePadding>
                        <ListItemButton onClick={(e) => onTimesheetViewclick(e, item)} sx={{ py: isRightColumn? 0.38:1 }}>
                          <ListItemText primary={ <Stack direction={"row"} sx={{ justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                <Typography variant="body1">
                                  {moment(item?.timesheetDate).format("MMMM DD, YYYY")}
                                </Typography>
                                <Stack direction={"row"} spacing={2}>
                                  <Stack sx={{ alignItems: "center" }}>
                                    <Typography variant="body1" sx={{ color: "text.secondary" }}>
                                      {TEXT_JOBS}
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: "text.primary", fontWeight: "bold" }}>
                                      {item?.noOfJobs ?? 0}
                                    </Typography>
                                  </Stack>
                                  <Stack sx={{ alignItems: "center" }}>
                                    <Typography variant="body1" sx={{ color: "text.secondary" }}>
                                      {"Hours"}
                                    </Typography>
                                    <Typography variant="body1" sx={{ color: "text.primary", fontWeight: "bold" }}>
                                      {`${hours}:${minutes}`}
                                    </Typography>
                                  </Stack>
                                </Stack>
                              </Stack>
                            }
                          />
                        </ListItemButton>
                      </ListItem>
                    </Card>
                  );
                })}
              </Stack>
            </List>
          ) : (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", flexGrow: 1, p: 3 }}>
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                {TEXT_NO_TIMESHEET_PLACEHOLDER}
              </Typography>
            </Box>
          )}
        </Stack>
      </Card>
    );
  };

  const expensesCard = () => {
    return (
      <Card
        sx={{
          borderRadius: "16px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.03)",
          border: "1px solid #f1f5f9",
          p: 2.5,
          cursor: "pointer",
          height: "100%",
          minHeight: "260px",
          display: "flex",
          flexDirection: "column",
          transition: "transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 20px 40px rgba(0,0,0,0.06)",
            borderColor: "#cbd5e1"
          }
        }}
      >
        <Stack spacing={1.5} sx={{ height: "100%", flexGrow: 1 }}>
          <Stack sx={{ justifyContent: "space-between", alignItems: "center" }} direction={"row"}>
            <Typography sx={{ cursor: "pointer", fontWeight: "900", letterSpacing: "-0.5px" }} variant="h5" onClick={goToExpenses}>
              {TEXT_EXPENSES}
            </Typography>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <IconButton
                onClick={() => {
                  setShowAddExpensesModal(true);
                }}>
                <AddIcon />
              </IconButton>
              {dashboardData?.expenses?.length > 0 && (
                <Button
                  size="small"
                  color="inherit"
                  variant="contained"
                  sx={{ textTransform: "none", borderRadius: "12px", boxShadow: "none", fontSize: "12px", py: 0.5, px: 1.5 }}
                  onClick={goToExpenses}>
                  {TEXT_SEE_ALL}
                </Button>
              )}
            </Stack>
          </Stack>
          {dashboardData?.expenses !== null && dashboardData?.expenses?.length > 0 ? (
            <List disablePadding sx={{ flexGrow: 1 }}>
              <Stack spacing={1}>
                {dashboardData?.expenses?.map((item, index) => (
                  <Card
                    key={index.toString()}
                    sx={{
                      borderRadius: "12px",
                      border: "1px solid #f1f5f9",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.01)",
                      transition: "transform 0.2s ease",
                      "&:hover": {
                        transform: "scale(1.01)",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.04)"
                      }
                    }}
                  >
                    <ListItem sx={{ m: 0, color: "text.primary" }} key={index.toString()} disablePadding secondaryAction={ <Typography variant="h6">
                          $ {item.totalAmount ? item.totalAmount.toFixed(2) : ""}
                        </Typography>
                      }>
                      <ListItemButton
                        onClick={() => {
                          setSelectedExpense(item);
                          setShowEditExpensesModal(true);
                        }}>
                        <ListItemText
                          primary={item.description}
                          secondary={moment(item.expenseDate).format("MMMM DD, YYYY")}
                        />
                      </ListItemButton>
                    </ListItem>
                  </Card>
                ))}
              </Stack>
            </List>
          ) : (
            <Box sx={{ textAlign: "center", p: 3, display: "flex", alignItems: "center", justifyContent: "center", flexGrow: 1 }}>
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                {TEXT_EXPENSES_PLACEHOLDER}
              </Typography>
            </Box>
          )}
        </Stack>
      </Card>
    );
  };

  // After add reward refresh the reward count
  const refreshBuilderBucks = async () => {
    try {
      const userRewardUrl = `${USER_REWARD_AMOUNT}/${userId}`;
      let getResponse = await Getrequestcall(userRewardUrl, accessToken);
      if (getResponse?.data?.data) {
        dispatch(setBuilderBucksCount(getResponse?.data?.data?.bucks ?? 0));
      }
    } catch (error) {
      console.log("getBuilderBucksCountAction-> Error When Getting Builder Bucks Count: ", error);
      dispatch(setBuilderBucksCount(0));
    }
  };

  const callAsk = async (currentQuestion) => {
    const trimmedQuestion = currentQuestion?.trim();
    if (!trimmedQuestion) {
      return;
    }
    const requestId = Date.now();
    try {
      setChatbotLoader(true);
      setOpenChatbot(true);
      setQuestion("");
      setChatbotResponse((prev) => {
        const previousHistory = Array.isArray(prev) ? prev : prev ? [prev] : [];
        return [
          ...previousHistory,
          {
            id: requestId,
            question: trimmedQuestion,
            answer: "",
            sources: [],
            isPending: true
          }
        ];
      });
      let historyId = currentChatHistoryIdRef.current ?? 0;
      const userId = loginData?.userInformation?.UserId ?? 0;
      const token = loginData?.accessToken ?? "";

      if (!historyId && userId && token) {
        try {
          const savePayload = {
            UserId: userId,
            ReturnRecordId: true,
            ReturnRecordError: true,
            SaveList: [
              {
                Id: 0,
                UserId: userId,
                Description: trimmedQuestion,
                ModifiedBy: userId
              }
            ]
          };
          const saveRes = await Postrequestcall(
            RAG_SAVE_CHATBOT_HISTORY_ID_DETAILS,
            savePayload,
            token
          );
          const getId =
            saveRes?.data?.data?.[0]?.objData?.id ??
            saveRes?.data?.data?.[0]?.id ??
            saveRes?.data?.objData?.id ??
            saveRes?.data?.id ??
            0;
          historyId = Number(getId) || 0;
          if (historyId) {
            updateCurrentChatHistoryId(historyId);
          }
        } catch (e) {
          historyId = 0;
        }
      }

      let payload = {
        question: trimmedQuestion,
        filters: {},
        userId,
        HistoryDetailId: historyId
      };
      let response = await Postrequestcall(RAG_ASK, payload, token);
      const responseData = response?.data?.data ?? response?.data ?? response ?? {};
      const parsedAnswer = parseHistoryAnswer(responseData);
      setChatbotResponse((prev) => {
        const previousHistory = Array.isArray(prev) ? prev : prev ? [prev] : [];
        return previousHistory.map((item) =>
          item?.id === requestId
            ? {
                ...item,
                answer: parsedAnswer.answer,
                sources: parsedAnswer.sources,
                videos: parsedAnswer.videos,
                isPending: false
              }
            : item
        );
      });
    } catch (error) {
      console.log("Error occurred while calling RAG_ASK: ", error);
      setChatbotResponse((prev) => {
        const previousHistory = Array.isArray(prev) ? prev : prev ? [prev] : [];
        return previousHistory.map((item) =>
          item?.id === requestId
            ? {
                ...item,
                answer: "Something went wrong. Please try again.",
                sources: [],
                isPending: false
              }
            : item
        );
      });
    } finally {
      setChatbotLoader(false);
    }
  };

  const onQuetionchange = (e) => {
    setQuestion(e.target.value);
  };

  const renderChatbotBar = () => (
    <Box
      className="chat-bot"
      sx={{ mb: 0 }}
    >
      <Box
        className="chat-icon"
        onClick={() => {
          resetChatbotToNewChat();
        }}
        sx={{ cursor: "pointer" }}
      >
        <SmartToyIcon className="chat-icon-svg" />
      </Box>
      <Box className="chat-input-wrapper">
        <TextField
          fullWidth
          placeholder="Ask me about BuildID..."
          value={question}
          onChange={onQuetionchange}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              callAsk(question);
            }
          }}
          variant="outlined"
          className="chat-input"
        />
        <IconButton
          className="send-btn"
          onClick={() => {
            callAsk(question);
          }}>
          <SendIcon />
        </IconButton>
      </Box>
    </Box>
  );

  // 7. Return UI
  return (
    <>
      <Box className="main-content-Box" sx={{ p: isSmallScreen ? 2 : 3 }}>
        <Box sx={{ mt: 0 }}>
          <Grid container spacing={2.5}>
            {isLoading ? (
              <>
                <Grid size={{ xs: 12, md: 8 }}>
                  <Stack spacing={2.5}>
                    {userInfoCardSkeleton()}
                    {questionsSkeleton()}
                    {<SiteCardSkeleton />}
                  </Stack>
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                  <Stack spacing={2.5}>
                    {<AdsCarouselSkeleton />}
                    {timesheetCardSkeleton()}
                    {expensesCardSkeleton()}
                  </Stack>
                </Grid>
              </>
            ) : (
              <>
                {/* Left Column - Main Content & Details */}
                <Grid size={{ xs: 12, md: 8 }}>
                  <Stack spacing={2.5}>
                    {isLessThan1200 && renderChatbotBar()}
                    {userInfoCard()}
                    {dashboardData?.isProgressBarDismiss == false && progressCard()}
                    {siteCard()}
                    {jobCard()}
                  </Stack>
                </Grid>

                {/* Right Column - Dynamic Actions & Widgets */}
                <Grid size={{ xs: 12, md: 4 }}>
                  <Stack spacing={2.5}>
                    {!isLessThan1200 && renderChatbotBar()}
                    {showDailyChallenge && (
                      <Box ref={dailyChallengeRef}>
                        <DailyChallengeCard
                          refreshDashboard={refreshBuilderBucks}
                          initialSummary={dailyChallengeSummary}
                          autoOpenModal={autoOpenDailyChallenge}
                        />
                      </Box>
                    )}
                    {adsData.length > 0 && <AdsCarousel adsData={adsData} />}
                    {!showDailyChallenge && timesheetCard(true)}
                    <AdContainer />
                  </Stack>
                </Grid>

                {/* When Daily Challenge is present: Timesheets and Expenses side-by-side (50% / 50% width) */}
                {showDailyChallenge ? (
                  <>
                    <Grid size={{ xs: 12, md: 6 }}>
                      {timesheetCard()}
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                      {expensesCard()}
                    </Grid>
                  </>
                ) : (
                  /* When Daily Challenge is not present: Expenses full width */
                  <Grid size={{ xs: 12 }}>
                    {expensesCard()}
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </Box>

        {/* Existing Modals */}
        {openPostCommentModalWithSource && (
          <PostComment
            open={openPostCommentModalWithSource}
            onClose={() => setOpenPostCommentModalWithSource(false)}
            from="new-dashboard"
            postItem={dashboardData?.announcement}
          />
        )}

        {showAddExpensesModal && (
          <Addexpenses
            isOpen={showAddExpensesModal}
            fetchExpenses={fetchDashboardData}
            editListItemDetails={selectedExpense}
            onClose={() => {
              setSelectedExpense(null);
              setShowAddExpensesModal(false);
            }}
            setSaveExpensesFlag={setSaveExpensesFlag}
            setShowEditExpensesModal={setShowEditExpensesModal}
          />
        )}

        {showEditExpensesModal && (
          <ViewExpenses
            openModal={showEditExpensesModal}
            closeModal={() => {
              setShowEditExpensesModal(false);
              setSaveExpensesFlag(false);
              setSelectedExpense(null);
            }}
            expensesDataId={selectedExpense}
            setShowAddExpensesModal={setShowAddExpensesModal}
            setSelectedExpense={setSelectedExpense}
            saveExpensesFlag={saveExpensesFlag}
            fetchExpensesData={fetchDashboardData}
            activeTab={"SENT"}
          />
        )}

        {surveyModal && (
          <SurveyModal
            open={surveyModal}
            onClose={() => {
              setSurveyModal(false);
            }}
            setQuizModal={setQuizModal}
          />
        )}
        {quizModal && (
          <SurveyQuizModal
            setSurveyModal={setSurveyModal}
            open={quizModal}
            onClose={() => {
              setQuizModal(false);
            }}
          />
        )}
        {addSiteWebsiteModalOpen && (
          <AddWebsiteModal
            open={addSiteWebsiteModalOpen}
            onClose={() => {
              setAddSiteWebsiteModalOpen(false);
            }}
            from="SiteCard"
            data={siteInfo || {}}
            onSaveClick={() => {
              let id = [...siteLoading];
              id.push(siteInfo?.id || 0);
              setSiteLoading(id);
            }}
            onDataSave={() => {
              let clone = dashboardData?.sites;

              const updatedData = clone?.map((site) => {
                if (site?.id === siteInfo?.id) {
                  return {
                    ...site,
                    website: " "
                  };
                } else {
                  return site;
                }
              });
              dispatch(
                setDashboardData({
                  ...dashboardData,
                  sites: updatedData
                })
              );
              let id = siteLoading;
              id.pop(siteInfo?.id || 0);
              setSiteLoading(id);
            }}
          />
        )}
        {addDescriptionDialogOpen && (
          <AddDescription
            getSiteDescriptions={() => console.log()}
            handleClose={() => {
              setAddDescriptionDialogOpen(false);
            }}
            addDescriptionDialogOpen={addDescriptionDialogOpen}
          />
        )}

        {/* 🎯 Timesheet Modals */}

        {timesheetAction === "view" && showTimesheetModal && (
          <TimesheetViewModal
            open={showTimesheetModal}
            onClose={() => setShowTimesheetModal(false)}
            seletetdTimesheet={selectedTimesheet}
            loginData={loginData}
            isSmallScreen={isSmallScreen}
            onEdit={(detail, timeSheetEnteries) => {
              console.log("Edit data received:", detail);
              // Switch to edit mode
              setTimesheetAction("add");
              setOperation("edit");
              setSelectedJob([...timeSheetEnteries]);
              setSelectedTimesheet({
                ...selectedTimesheet,
                ...detail, // Ensure we have the complete timesheet data
                id: selectedTimesheet?.id || detail?.id // Make sure ID is preserved
              });
              // Keep modal open for editing
            }}
            onSend={handleSendTimesheet}
            onPictureViewerOpen={(pictures, index) => {
              setImageArray(pictures);
              setImageIndex(index);
              setPictureViewer(true);
            }}
            onDeleteComplete={async (deletedTimesheet) => {
              console.log("Delete completed for:", deletedTimesheet); // ✅ ADD DEBUG
              await fetchDashboardData();
              setShowTimesheetModal(false);
              setSelectedTimesheet(null); // ✅ FIXED: Clear selected timesheet
            }}
          />
        )}

        {/* Clock In Modal */}
        <AddClockIn
          open={showClockInModal}
          onClose={() => setShowClockInModal(false)}
          seletetdClockInTimesheet={seletetdClockInTimesheet}
          operation={operation}
          selectedClockInJob={selectedClockInJob}
          setSelectedClokInJob={setSelectedClockInJob}
          loginData={loginData}
          goallist={goallist}
          isSmallScreen={isSmallScreen}
          onSaveComplete={handleTimesheetSaveComplete}
          onGoalModalOpen={() => {}} // No goal modal in dashboard
          onJoblistOpen={() => setShowJoblist(true)}
        />
        {timesheetAction === "add" && showTimesheetModal && (
          <AddEditTimesheetModel
            open={showTimesheetModal}
            onClose={() => setShowTimesheetModal(false)}
            operation={operation}
            initialUser={
              operation === "edit"
                ? selectedTimesheet // ✅ FIXED: Use selectedTimesheet for edit mode
                : {
                    timesheetDate: moment().format("YYYY-MM-DD"),
                    totalHours: "00:00",
                    isSent: false
                  }
            }
            selectedJob={selectedJob}
            setSelectedJob={setSelectedJob}
            loginData={loginData}
            goallist={goallist}
            userGoalData={userGoalData}
            onSaveComplete={handleTimesheetSaveComplete}
            onJoblistOpen={() => setShowJoblist(true)}
          />
        )}

        <SendTimesheet
          open={showSendTimesheet}
          onClose={() => setShowSendTimesheet(false)}
          selectedTimesheets={selectedTimesheetsToSend}
          loginData={loginData}
          onSendComplete={async () => {
            await fetchDashboardData();
            setShowTimesheetModal(false);
            setSelectedTimesheetsToSend([]);
            setShowSendTimesheet(false);
          }}
        />

        {/* Job Selection Modal */}
        <Joblist
          open={showJoblist}
          onClose={() => setShowJoblist(false)}
          loginData={loginData}
          selectedJob={selectedJob}
          setSelectedJob={setSelectedJob}
          selectedClockInJob={selectedClockInJob}
          setSelectedClokInJob={setSelectedClockInJob}
          isClockIn={showClockInModal}
          seletetdClockInTimesheet={seletetdClockInTimesheet}
          roleIndex={1}
        />

        {/* Picture Viewer */}
        <PictureViewer
          isOpen={pictureViewerOpen}
          onClose={() => setPictureViewer(false)}
          pictures={imageArray.map((item, i) => ({
            src: item?.pictureUrl ? item?.pictureUrl : URL.createObjectURL(item)
          }))}
          viewerIndex={imageIndex}
        />

        {/* Timesheet Add Menu */}
        <Menu
          id="timesheet-menu"
          MenuListProps={{
            "aria-labelledby": "timesheet-menu-button"
          }}
          anchorEl={timesheetMenuAnchorEl}
          open={timesheetMenuOpen}
          onClose={handleTimesheetMenuClose}
          TransitionComponent={Fade}>
          <MenuItem onClick={handleClick}>
            <ListItem disablePadding>
              <ListItemButton>
                <AddCircleIcon sx={{ mr: 1 }} />
                <ListItemText primary={TEXT_NEW_TIMESHEET} />
              </ListItemButton>
            </ListItem>
          </MenuItem>
          <MenuItem onClick={handleClockInClick}>
            <ListItem disablePadding>
              <ListItemButton>
                <AccessTimeIcon sx={{ mr: 1 }} />
                <ListItemText primary={TEXT_ADD_CLOCKIN} />
              </ListItemButton>
            </ListItem>
          </MenuItem>
        </Menu>
      </Box>

      <Chatbot
        key={chatbotSessionKey}
        callAsk={callAsk}
        openChatbot={openChatbot}
        setOpenChatbot={setOpenChatbot}
        chatbotResponse={chatbotResponse}
        chatbotLoader={chatbotLoader}
        setChatbotResponse={setChatbotResponse}
        setChatbotLoader={setChatbotLoader}
        setQuestion={setQuestion}
        clearCurrentChatThread={clearCurrentChatThread}
        setCurrentChatHistoryId={updateCurrentChatHistoryId}
        normalizeChatbotHistoryRecord={normalizeChatbotHistoryRecord}
      />
    </>
  );
};

export default Home;
